import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
const initialState = {
  isConnected: false,
};

const conSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {
    onConnection: (state, action) => {
      state.isConnected = action.payload;
    },
  },
});
export const onConnection = conSlice.actions.onConnection;
export default conSlice.reducer;
